import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/HomePurchaseOrderDefaults'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class HomePurchaseOrderDefaultsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "HomePurchaseOrderDefaultsStore",
			variables: false,
		})
	}
}

export async function load_HomePurchaseOrderDefaults(params) {
  await initClient()

	const store = new HomePurchaseOrderDefaultsStore()

	await store.fetch(params)

	return {
		HomePurchaseOrderDefaults: store,
	}
}
